import { render, staticRenderFns } from "./GpForms.vue?vue&type=template&id=0b19e08c&"
import script from "./GpForms.vue?vue&type=script&lang=js&"
export * from "./GpForms.vue?vue&type=script&lang=js&"
import style0 from "./GpForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports